export default __webpack_public_path__ + "static/media/Scalable (2).ea4179b0.png";